export default __webpack_public_path__ + "assets/models/d9d52d5387f5c28b59ae4c59be97239d.glb";